module.exports = __webpack_public_path__ + "img/deodorizer_machine.82463a21.svg";